import { render, staticRenderFns } from "./AppsView.vue?vue&type=template&id=45cdd6ca"
import script from "./AppsView.vue?vue&type=script&lang=js"
export * from "./AppsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports